import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { Actor, ActorMap } from '../../types';

interface ActorState {
  customActors: ActorMap;
  selectedCustomActor: Actor;
}

const initialState: ActorState = {
  customActors: {},
  selectedCustomActor: {
    userId: '',
    userType: 'actor',
    username: '',
    prompt: '',
    owner: '',
    isCustomActor: true,
  },
};

export const actorSlice = createSlice({
  name: 'actor',
  initialState,
  reducers: {
    setCustomActors: (state, action: PayloadAction<Actor[]>) => {
      const actors: ActorMap = {};
      for (const actor of action.payload) {
        actors[actor.userId] = actor;
      }
      state.customActors = actors;
    },
    setSelectedCustomActor: (state, action: PayloadAction<Actor>) => {
      state.selectedCustomActor = action.payload;
    },
    addCustomActor: (state, action: PayloadAction<Actor>) => {
      const actor = action.payload;
      state.customActors[actor.userId] = actor;
    },
  },
});

export const { setCustomActors, setSelectedCustomActor, addCustomActor } =
  actorSlice.actions;

export const selectCustomActors = (state: RootState) =>
  state.actor.customActors;

export const selectSelectedCustomActor = (state: RootState) =>
  state.actor.selectedCustomActor;

export const selectCustomActorsList = createSelector(
  selectCustomActors,
  (map) =>
    Object.values(map).sort((u1, u2) => u1.userId.localeCompare(u2.userId))
);

export default actorSlice.reducer;
